import React, { useState, useEffect } from "react";
import { Layout, Button, Drawer } from "antd";
import LeftMenu from "./LeftMenu";
import RightMenu from "./RightMenu";
import { MenuOutlined } from "@ant-design/icons";
import { useLocation, Link } from "react-router-dom";
import Logo from '../assets/images/Mr-Chap.png'

const NavBar = () => {
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(!visible);
  };

  // If you do not want to auto-close the mobile drawer when a path is selected
  // Delete or comment out the code block below
  // From here
  let { pathname: location } = useLocation();
  useEffect(() => {
    setVisible(false);
  }, [location]);
  // Upto here

  return (
    <nav className="navbar">
      <Layout>
        <Layout.Header className="nav-header">
          <div className="logo" style={{"textAlign":"left"}}>
          <Link to="/"><img src={Logo} width={67} height={67}></img></Link>
          </div>
          <div className="navbar-menu">
            <div style={{width:"130px", float:"left"}}>
            <RightMenu mode={"horizontal"} />

            </div>
            <Button style={{width:"30px"}} className="menuButton" type="text" onClick={showDrawer}>
              <MenuOutlined style={{position:"absolute",top:"9px"}}/>
            </Button>
            <div className="rightMenu">
            <LeftMenu mode={"horizontal"} />

            </div>

            <Drawer
              title={<img src={Logo} width={67} height={67}></img>}
              placement="right"
              closable={true}
              onClose={showDrawer}
              visible={visible}
              style={{ zIndex: 99999 }}
            >
              <LeftMenu mode={"inline"} />
              <RightMenu mode={"inline"} />
            </Drawer>
          </div>
        </Layout.Header>
      </Layout>
    </nav>
  );
};

export default NavBar;